<ng-container *ngIf="pagination.results != null">
    <h2 class="text-3xl font-bold mb-3" *ngIf="showTitle">{{title}} <small class="text-secondary fw-normal">({{pagination.resultsCount}})</small></h2>

    <div class="bg-card shadow-lg rounded-xl">
    
        <div class="grid gap-6 grid-cols-1 md:grid-cols-2 border-b p-4 items-center">
            <div>
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-icon matIconPrefix [svgIcon]="'tabler_outline:search'"></mat-icon>
                    <input type="text" matInput [formControl]="searchControl" placeholder="Szukaj klienta">
                    <button mat-icon-button matIconSuffix  (click)="reset()" *ngIf="searchControl.value.length > 0">
                        <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
                    </button>
                  
                    <mat-hint *ngIf="searchControl.value.length > 0" >
                        <span>Wyniki wyszukiwania dla frazy: </span> {{searchControl.value}}
                    </mat-hint>
                </mat-form-field>
            </div>
            <div class="justify-self-end">
                <pagination  class="flex items-center" [currentPage]="pagination.currentPage"
                [totalPages]="pagination.pages" (onPageChange)="onPageChange($event)"></pagination>
            </div>
        </div>
    
        <!-- <div class="grid gap-6 grid-cols-1 border-b p-4" *ngIf="pagination.results?.length > 0 && (showMarkAsPaidButton || showMarkAsTemplateButton || showIssueSimilarButton)">
            <div class="flex items-center">
                <mat-icon [svgIcon]="'tabler_outline:corner-up-right'"   class="tools-icon"></mat-icon>
            </div>
        </div> -->

        <!-- Header -->
        <div class="grid grid-cols-12 bg-gray-50 dark:bg-gray-900 items-center border-b border-t px-6 py-2 text-sm content-center text-secondary font-semibold" *ngIf="pagination && pagination.results && pagination.results.length > 0">
            
            <div class="col-span-1 ">
                #
            </div>
            <div class="col-span-11 sm:col-span-6 ">
                Klient
            </div>
            <div class="hidden sm:block sm:col-span-2 ">
                Identyfikator
            </div>
            <div class="hidden sm:block sm:col-span-3 ">
                Adres
            </div>

        </div>

        <!-- Body -->
        <div class="grid grid-cols-12 cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-700 px-6 py-4 border-b" [routerLink]="client._id"  *ngFor="let client of pagination.results; let i = index">
            
            <div class="col-span-1">
                {{i + pagination.pageSize * (pagination.currentPage - 1) + 1}}
            </div>

            <div class="col-span-11 sm:col-span-6 ">
                <company-name [company]="client"></company-name>
                <div class="sm:hidden">
                    <div class="text-md" *ngIf="client.identifierType !== 'none' && (client.nip || client.vatUE || client.otherTaxIdentifier || client.idWew)">
                        <span *ngIf="client.identifierType === 'vatEu' && client.vatUE">
                            VAT UE: <span class="text-secondary" [class.text-yellow-600]="isDuplicateCountryCode(client.vatUE, client.countryCode)" [class.dark:text-yellow-400]="isDuplicateCountryCode(client.vatUE, client.countryCode)">{{formatVatUE(client.vatUE, client.countryCode)}}</span><mat-icon *ngIf="isDuplicateCountryCode(client.vatUE, client.countryCode)" class="text-yellow-600 dark:text-yellow-400 !w-3 !h-3 !text-[12px] ml-1 -mt-0.5" style="vertical-align: middle; display: inline-block;" [svgIcon]="'heroicons_solid:exclamation-triangle'" matTooltip="Numer VAT UE zawiera zduplikowany kod kraju. Edytuj klienta i popraw numer."></mat-icon>
                        </span>
                        <span *ngIf="client.identifierType === 'other' && client.otherTaxIdentifier">
                            ID: <span class="text-secondary">{{client.otherTaxIdentifier}}</span>
                        </span>
                        <span *ngIf="client.identifierType === 'idWew' && client.idWew">
                            ID wewnętrzny: <span class="text-secondary">{{client.idWew}}</span>
                        </span>
                        <span *ngIf="client.identifierType !== 'vatEu' && client.identifierType !== 'other' && client.identifierType !== 'idWew' && client.nip">
                            NIP: <span class="text-secondary">{{client.nip}}</span>
                        </span>
                    </div>
                    <div class="text-md">
                        {{ client | clientAddress }}
                    </div>
                    <!-- KSeF warning for mobile -->
                    <div *ngIf="hasKsefWarning(client)" 
                         class="flex items-center gap-1.5 mt-0.5 text-amber-700 dark:text-amber-400"
                         [matTooltip]="getKsefWarnings(client).join(', ')">
                        <mat-icon class="icon-size-4 flex-shrink-0 text-amber-500" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                        <span class="text-xs leading-tight">Uzupełnij dane tego podmiotu, aby wysyłać faktury do KSeF</span>
                    </div>
                </div>
            </div>

            <div class="hidden sm:block sm:col-span-2">
                <span *ngIf="client.identifierType === 'vatEu' && client.vatUE" [class.text-yellow-600]="isDuplicateCountryCode(client.vatUE, client.countryCode)" [class.dark:text-yellow-400]="isDuplicateCountryCode(client.vatUE, client.countryCode)">
                    {{formatVatUE(client.vatUE, client.countryCode)}}<mat-icon *ngIf="isDuplicateCountryCode(client.vatUE, client.countryCode)" class="text-yellow-600 dark:text-yellow-400 !w-3 !h-3 !text-[12px] ml-1 -mt-0.5" style="vertical-align: middle; display: inline-block;" [svgIcon]="'heroicons_solid:exclamation-triangle'" matTooltip="Numer VAT UE zawiera zduplikowany kod kraju. Edytuj klienta i popraw numer."></mat-icon>
                </span>
                <span *ngIf="client.identifierType === 'other' && client.otherTaxIdentifier">
                    {{client.otherTaxIdentifier}}
                </span>
                <span *ngIf="client.identifierType === 'idWew' && client.idWew">
                    {{client.idWew}}
                </span>
                <span *ngIf="client.identifierType && client.identifierType !== 'vatEu' && client.identifierType !== 'other' && client.identifierType !== 'idWew' && client.identifierType !== 'none' && client.nip">{{client.nip}}</span>
                <span *ngIf="!client.identifierType && client.nip">{{client.nip}}</span>
                <span *ngIf="!client.identifierType && !client.nip && client.vatUE" [class.text-yellow-600]="isDuplicateCountryCode(client.vatUE, client.countryCode)" [class.dark:text-yellow-400]="isDuplicateCountryCode(client.vatUE, client.countryCode)">
                    {{formatVatUE(client.vatUE, client.countryCode)}}<mat-icon *ngIf="isDuplicateCountryCode(client.vatUE, client.countryCode)" class="text-yellow-600 dark:text-yellow-400 !w-3 !h-3 !text-[12px] ml-1 -mt-0.5" style="vertical-align: middle; display: inline-block;" [svgIcon]="'heroicons_solid:exclamation-triangle'" matTooltip="Numer VAT UE zawiera zduplikowany kod kraju. Edytuj klienta i popraw numer."></mat-icon>
                </span>
            </div>

            <div class="hidden sm:block sm:col-span-3">
                {{ client | clientAddress }}
                
                <!-- KSeF warning for desktop -->
                <div *ngIf="hasKsefWarning(client)" 
                     class="flex items-center gap-1.5 mt-0.5 text-amber-700 dark:text-amber-400"
                     [matTooltip]="getKsefWarnings(client).join(', ')">
                    <mat-icon class="icon-size-4 flex-shrink-0 text-amber-500" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                    <span class="text-xs leading-tight">Uzupełnij dane tego podmiotu, aby wysyłać faktury do KSeF</span>
                </div>
            </div>
        </div>
    
        <div class="flex items-center border-b p-8 content-center" *ngIf="pagination.results.length == 0">
            <div class="text-secondary" *ngIf="searchControl.value.length > 0">Nie znaleziono klientów.</div>
            <div class="text-secondary" *ngIf="searchControl.value.length == 0 && showAddNewButton && pagination.resultsCount == 0">
    
                <button mat-button color="primary" [routerLink]="'/konto/dokumenty/wystaw'">
                    <mat-icon matPrefix [svgIcon]="'tabler_outline:plus'"></mat-icon>
                    <span class="ml-2">Dodaj pierwszego klienta</span>
                </button>
            </div>
        </div>

        <div class="grid gap-6 grid-cols-1 p-4 items-center" *ngIf="pagination && pagination.results && pagination.results.length > 0">
            <div class="justify-self-end">
                <pagination  class="flex items-center" [currentPage]="pagination.currentPage || 1"
                [totalPages]="pagination.pages || 0" (onPageChange)="onPageChange($event)"></pagination>
            </div>
        </div>
    
    </div>
</ng-container>

<mat-spinner *ngIf="pagination.results == null" color="primary" class="mx-auto"></mat-spinner>
